import script from "./slider.vue?vue&type=script&setup=true&lang=ts"
export * from "./slider.vue?vue&type=script&setup=true&lang=ts"

import "./slider.vue?vue&type=style&index=0&id=6949606d&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6949606d"]])

export default __exports__